import "./Language/domPatch";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./responsive.css";
import { initAnalytics, initClarity } from "./analytics";
import { whenIdle } from "./lib/deferIdle";
import { CONSENT_EVENT, getConsent } from "./lib/cookieConsent";

// Analytics, ad pixels and heatmap tools are non-critical: loading their
// scripts during the initial render competes with the hero media for bandwidth
// and delays LCP. They also only run once the visitor has accepted the
// matching cookie category (analytics or marketing).
let analyticsStarted = false;
const startAnalyticsIfAllowed = () => {
  const consent = getConsent();
  if (!consent) return;
  if (!consent.analytics && !consent.marketing) return;
  whenIdle(() => {
    initAnalytics();
    if (consent.analytics && !analyticsStarted) {
      analyticsStarted = true;
      initClarity();
    }
  });
};

startAnalyticsIfAllowed();
window.addEventListener(CONSENT_EVENT, startAnalyticsIfAllowed);


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <BrowserRouter>
  //   <App />
  // </BrowserRouter>
  <App />
);